import { getDecimalSeparator, parseLocaleNumber } from "./formatNumber";
import { getDecimalPlaces } from "./number-extensions";

export type DepthInputError = "notANumber" | "negative" | "tooManyDecimals";

export const parseDepthInput = (raw: string, locale?: string): number | null => {
  const trimmed = raw.trim();
  if (trimmed === "") return null;
  return parseLocaleNumber(trimmed, locale);
};

export const formatDepthInput = (value: number | null | undefined, locale?: string): string =>
  value == null ? "" : value.toString().replace(".", getDecimalSeparator(locale));

export const depthInputError = (raw: string, locale?: string): DepthInputError | undefined => {
  if (raw.trim() === "") return undefined;
  const value = parseDepthInput(raw, locale);
  if (value === null) return "notANumber";
  if (value < 0) return "negative";
  if (getDecimalPlaces(value) > 2) return "tooManyDecimals";
  return undefined;
};
